import React from 'react'

export default function ProjectImage() {
    return (
        <div className='project-embed'>
            <div className='banner'>
                "REASONS" CULTURE JAM
            </div>
            <div className='box-image'>

            </div>
            <div className='box-5'>
                Softwares Used: AI <br /> <br />
                Drinking has been around since the near beginning of civilization. It has been essential in past trade and cultural progression, but it has also done it’s job keeping people well distracted with pleasure. In recent times, distraction and pleasure seeking has reached an increasing all-time high as our civilization and planet face a new crisis every week. With this in mind, my Culture Jam project used the idea of the fake to create a brand of alcoholic drinks that promoted awareness of recent events. It takes a humorous and almost contradictory tone in the way the idea is promoted, yet presents itself clearly nonetheless.
                <a href="https://www.google.com" target="_blank" className='button-container'>
                    <div className='essay-link'  > Read the Full Essay</div>
                </a>
            </div>
        </div>
    )
}
